import { ExclamationIcon } from "@heroicons/react/outline";
import { CheckCircle, DisabledByDefault } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Button } from "../../../../components/common/Button/Button";
import LoadingSpinner from "../../../../components/common/LoadingSpinner/LoadingSpinner";
import SimpleOverlay from "../../../../components/common/SimpleOverlay/SimpleOverlay";
import Auth from "../../../../services/Auth/Auth";
import IzinMajuSidangService from "../../../../services/Integration/izin-maju-sidang/IzinMajuSidangService";

export default function IzinMajuSidangCard({ mKSpesialId }) {
  const [isLoading, setIsLoading] = useState({
    fetchData: true,
    submit: false,
  });
  const user = Auth.getCurrentUser();
  const [izinMajuSidangs, setIzinMajuSidangs] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => getIzinMajuSidang(), []);

  const getIzinMajuSidang = async () => {
    setIsLoading({ ...isLoading, fetchData: true });
    await IzinMajuSidangService.getIzinMajuSidang(mKSpesialId).then(
      (response) => {
        if (response.status === 200) {
          setIzinMajuSidangs(response.data);
        }
      }
    );
    setIsLoading({ ...isLoading, fetchData: false });
  };

  const getIzinMajuSidangPribadi = () =>
    izinMajuSidangs.filter(
      (izinMajuSidang) => izinMajuSidang.dosen.id_dosen === user.id
    )[0];

  const getIzinMajuSidangDosenLain = () =>
    izinMajuSidangs.filter(
      (izinMajuSidang) => izinMajuSidang.dosen.id_dosen !== user.id
    );

  const handlePutIzinMajuSidang = async (status) => {
    setIsLoading({ ...isLoading, submit: true });
    await IzinMajuSidangService.putIzinMajuSidang(mKSpesialId).then(
      (response) => {
        if (response.status === 200) {
          setAlertMessage(
            `Izin maju sidang ${status ? "disetujui" : "dibatalkan"}.`
          );
          setShowAlert(true);
        } else {
          const data = response.data;
          setAlertMessage("Gagal memberi izin maju sidang. " + data.err ?? "");
          setShowAlert(true);
        }
      }
    );
    setIsLoading({ ...isLoading, submit: false });
  };

  return (
    <div>
      {isLoading.fetchData ? (
        <LinearProgress />
      ) : (
        <>
          {izinMajuSidangs !== null &&
          getIzinMajuSidangPribadi().is_approved ? (
            <div className="flex justify-center">
              <LoadingButton
                loading={isLoading.submit}
                onClick={() => handlePutIzinMajuSidang(false)}
              >
                {isLoading.submit ? (
                  <LoadingSpinner />
                ) : (
                  <span className="py-2 px-4 rounded-md bg-red-600 text-white hover:bg-red-700">
                    Batalkan Maju Sidang
                  </span>
                )}
              </LoadingButton>
            </div>
          ) : (
            <div className="flex justify-center">
              <LoadingButton
                loading={isLoading.submit}
                onClick={() => handlePutIzinMajuSidang(true)}
              >
                {isLoading.submit ? (
                  <LoadingSpinner />
                ) : (
                  <span className="py-2 px-4 rounded-md bg-green-600 text-white hover:bg-green-700">
                    Setujui Maju Sidang
                  </span>
                )}
              </LoadingButton>
            </div>
          )}
          {izinMajuSidangs !== null &&
            getIzinMajuSidangDosenLain().length > 0 && (
              <>
                <hr className="my-2" />
                <div>
                  <div>Status Maju Sidang Dosen Lain:</div>
                  <ul className="list-disc ml-4">
                    {izinMajuSidangs !== null &&
                      getIzinMajuSidangDosenLain().map((izinMajuSidang) => (
                        <li key={izinMajuSidang.dosen.id_dosen}>
                          {izinMajuSidang.dosen.nama_lengkap}:{" "}
                          {izinMajuSidang.is_approved ? (
                            <CheckCircle htmlColor="green" />
                          ) : (
                            <DisabledByDefault htmlColor="#EC1D1D" />
                          )}
                        </li>
                      ))}
                  </ul>
                </div>
              </>
            )}
        </>
      )}
      <SimpleOverlay
        title={"Pemberitahuan!"}
        message={<div>{alertMessage}</div>}
        isOpen={showAlert}
        onClose={() => {}}
        icon={
          <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10">
            <ExclamationIcon stroke="blue" aria-hidden="true" />
          </div>
        }
        buttons={
          <>
            <Button
              color="blue"
              onClick={() => {
                setShowAlert(false);
                window.location.reload(false);
              }}
            >
              <span className="font-bold">Ok</span>
            </Button>
          </>
        }
      />
    </div>
  );
}
